export enum MediumTabAction {
  IMAGES = 'Images',
  SCENE_1 = 'Scene 1',
  SCENE_1_TAKE_200 = 'Scene 1 Take 200',
  SCENE_2 = 'Scene 2',
  SLATE = 'Scene 1',
}
